import { createReducer, on } from '@ngrx/store'
import * as AppActions from './app.actions'

export const appFeatureKey = 'app'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface State {}

export const initialState: State = {}

export const reducer = createReducer(
  initialState,

  on(AppActions.createApp, (state) => state),
  on(AppActions.createAppSuccess, (state, _action) => state),
  on(AppActions.createAppFailure, (state, _action) => state)
)
